import * as actionType from '../actions/actionTypes';
import updateObject from '../Utility';

const initState = {
    channel: {
        newInquiriesVisibleTo: 'all',//all,Admin
        whoCanAssignInquiries: 'all'//all,Admin
    },
    calls: {

    },
    users: {

    },
    source: {

    },
    dialList: {

    },
    callBack: {

    },
    general: {

    }
}

const fetchSettingsSuccess = (state, action) => {
    console.log('fetchSettingsSuccess')
    console.log(action)
    return updateObject(state, { ...action.companySettings });
}

const setSettings = (state, action) => {
    // debugger;
    let newChannel = undefined
    let newCalls = undefined
    let popUpCrmWindow = undefined
    let newCallBack = undefined
    let newCallBackProjects = undefined
    let newSource = undefined
    let indexOfProject = undefined
    let newGroups = undefined
    let newBot = undefined
    let newGeneral = undefined
    let newDialList = undefined
    if (action.settingType === 'channel') {
        switch (action.settingName) {
            case 'newInquiriesVisibleTo':
                newChannel = updateObject(state.channel, { newInquiriesVisibleTo: action.value })
                return updateObject(state, { channel: newChannel });
            case 'whoCanAssignInquiries':
                newChannel = updateObject(state.channel, { whoCanAssignInquiries: action.value })
                return updateObject(state, { channel: newChannel });
            case 'attachToBeginMsg':
                newChannel = updateObject(state.channel, { attachToBeginMsg: action.value })
                return updateObject(state, { channel: newChannel });
            case 'openOnInquirieType':
                newChannel = updateObject(state.channel, { openOnInquirieType: action.value })
                return updateObject(state, { channel: newChannel });
            case 'maxInProcessInquiries':
                newChannel = updateObject(state.channel, { maxInProcessInquiries: action.value })
                return updateObject(state, { channel: newChannel });
            case 'closeInquiriesAfterHours':
                newChannel = updateObject(state.channel, { closeInquiriesAfterHours: action.value })
                return updateObject(state, { channel: newChannel });
            case 'inquirieClosedMsg':
                newChannel = updateObject(state.channel, { inquirieClosedMsg: action.value })
                return updateObject(state, { channel: newChannel });
            case 'inquirieReminderMsg':
                newChannel = updateObject(state.channel, { inquirieReminderMsg: action.value })
                return updateObject(state, { channel: newChannel });
            case 'isLeadMailSupported':
                newChannel = updateObject(state.channel, { isLeadMailSupported: action.value })
                return updateObject(state, { channel: newChannel });
            case 'sendMsgToOpenInqNoResFromClientAfterHours':
                newChannel = updateObject(state.channel, { sendMsgToOpenInqNoResFromClientAfterHours: action.value })
                return updateObject(state, { channel: newChannel });
            case 'circularAssociateInquiriesWithAgent':
                newChannel = updateObject(state.channel, { circularAssociateInquiriesWithAgent: action.value })
                return updateObject(state, { channel: newChannel });
            default: return console.log('Wrong Setting name')
        }
    }
    else if (action.settingType === 'calls') {//incomingCall_enable
        switch (action.settingName) {
            case 'autoDial':
                newCalls = updateObject(state.calls, { autoDial: action.value })
                return updateObject(state, { calls: newCalls });
            case 'incomingCall_enable':
                popUpCrmWindow = updateObject(state.calls.popUpCrmWindow, { incomingCall_enable: action.value })
                newCalls = updateObject(state.calls, { popUpCrmWindow: popUpCrmWindow })
                return updateObject(state, { calls: newCalls });
            case 'incomingCall_onAnswer':
                popUpCrmWindow = updateObject(state.calls.popUpCrmWindow, { incomingCall_onAnswer: action.value })
                newCalls = updateObject(state.calls, { popUpCrmWindow: popUpCrmWindow })
                return updateObject(state, { calls: newCalls });
            default: return console.log('Wrong Setting name')
        }
    }//callBack
    else if (action.settingType === 'callBack') {
        switch (action.settingName) {
            case 'isEnable':
                newCallBack = updateObject(state.callBack, { isEnable: action.value })
                return updateObject(state, { callBack: newCallBack });
            case 'addCallBacksWhenDialerOpen':
                newCallBack = updateObject(state.callBack, { addCallBacksWhenDialerOpen: action.value })
                return updateObject(state, { callBack: newCallBack });
            case 'deleteAllCallbacksFromDialListWhenUserLogout':
                newCallBack = updateObject(state.callBack, { deleteAllCallbacksFromDialListWhenUserLogout: action.value })
                return updateObject(state, { callBack: newCallBack });
            case 'everySecToCheck':
                newCallBack = updateObject(state.callBack, { everySecToCheck: action.value })
                return updateObject(state, { callBack: newCallBack });
            case 'removeCallBackProject'://todo
                newCallBackProjects = [...state.callBack.callBackProjects]
                indexOfProject = newCallBackProjects.findIndex(project => project.project === action.value)
                if (indexOfProject > -1) {
                    newCallBackProjects.splice(indexOfProject, 1)
                }
                newCallBack = updateObject(state.callBack, { callBackProjects: newCallBackProjects })
                return updateObject(state, { callBack: newCallBack });
            case 'updateCallBackProject'://todo
                newCallBackProjects = [...state.callBack.callBackProjects]
                indexOfProject = newCallBackProjects.findIndex(project => project.project === action.value.searchProject)
                if (indexOfProject > -1) {
                    delete action.value.searchProject
                    newCallBackProjects[indexOfProject] = updateObject(newCallBackProjects[indexOfProject], action.value)
                }
                newCallBack = updateObject(state.callBack, { callBackProjects: newCallBackProjects })
                return updateObject(state, { callBack: newCallBack });
            case 'saveCallBackProject'://todo
                newCallBackProjects = [...state.callBack.callBackProjects, action.value]
                newCallBack = updateObject(state.callBack, { callBackProjects: newCallBackProjects })
                return updateObject(state, { callBack: newCallBack });
            case 'removeCallBackProjectSubscribers'://todo
                newCallBackProjects = [...state.callBack.callBackProjects]
                indexOfProject = newCallBackProjects.findIndex(project => project.project === action.value.project)
                if (indexOfProject > -1) {
                    const subscribers = newCallBackProjects[indexOfProject].subscribers
                    const subscriberIndex = subscribers.findIndex(subscriber => subscriber === action.value.subscriber)
                    if (subscriberIndex > -1) {
                        subscribers.splice(subscriberIndex, 1)
                    }
                }
                newCallBack = updateObject(state.callBack, { callBackProjects: newCallBackProjects })
                return updateObject(state, { callBack: newCallBack });
            case 'saveCallBackProjectSubscribers'://todo
                newCallBackProjects = [...state.callBack.callBackProjects]
                indexOfProject = newCallBackProjects.findIndex(project => project.project === action.value.project)
                if (indexOfProject > -1) {
                    newCallBackProjects[indexOfProject].subscribers = [...newCallBackProjects[indexOfProject].subscribers, action.value.subscriber]
                }
                newCallBack = updateObject(state.callBack, { callBackProjects: newCallBackProjects })
                return updateObject(state, { callBack: newCallBack });
            default: return console.log('Wrong Setting name')
        }
    }
    else if (action.settingType === 'source') {
        switch (action.settingName) {
            case 'selectedSource':
                newSource = updateObject(state.source, { selectedSource: action.value })
                return updateObject(state, { source: newSource });
            default: return console.log('Wrong Setting name')
        }
    }
    else if (action.settingType === 'group') {
        switch (action.settingName) {
            case 'isGroupsSupported':
                newGroups = updateObject(state.groups, { isGroupsSupported: action.value })
                return updateObject(state, { groups: newGroups });
            case 'groupType':
                newGroups = updateObject(state.groups, { type: action.value })
                return updateObject(state, { groups: newGroups });
            default: return console.log('Wrong Setting name')
        }
    }
    else if (action.settingType === 'bot') {
        switch (action.settingName) {
            case 'onSetBotActivity':
                newBot = updateObject(state.bot, { activeBot: action.value })
                return updateObject(state, { bot: newBot });
            case 'activeStartDay':
                newBot = updateObject(state.bot, { activeStartDay: action.value });
                return updateObject(state, { bot: newBot });
            case 'activeEndDay':
                newBot = updateObject(state.bot, { activeEndDay: action.value });
                return updateObject(state, { bot: newBot });
            case 'activeStartTime':
                newBot = updateObject(state.bot, { activeStartTime: action.value });
                return updateObject(state, { bot: newBot });
            case 'activeEndTime':
                newBot = updateObject(state.bot, { activeEndTime: action.value });
                return updateObject(state, { bot: newBot });
            default: return console.log('Wrong Setting name')
        }
    }
    else if (action.settingType === 'general') {
        switch (action.settingName) {
            case 'onSetEnableFetchContactFromCrm':
                newGeneral = updateObject(state.general, { enableFetchContactFromCrm: action.value })
                return updateObject(state, { general: newGeneral });
            default: return console.log('Wrong Setting name')
        }
    }
    else if (action.settingType === 'dialList') {
        switch (action.settingName) {
            case 'autoCloseDialistOnEndCall':
                newDialList = updateObject(state.dialList, { autoCloseDialistOnEndCall: action.value })
                return updateObject(state, { dialList: newDialList });
            default: return console.log('Wrong Setting name')
        }
    }
}

const clearSettingsState = () => {
    return initState
}

const reducer = (state = initState, action) => {
    switch (action.type) {
        case actionType.FETCH_SETTINGS_SUCCESS: return fetchSettingsSuccess(state, action);
        case actionType.SET_SETTING: return setSettings(state, action);
        case actionType.CLEAR_SETTINGS_STATE: return clearSettingsState(state, action);
        default:
            return state
    }
}

export default reducer;